<app-loader></app-loader>
<p-confirmPopup></p-confirmPopup>
<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<div class="back-outer">
    <p (click)="backRoute()">
        <img src="../../../../../assets/images/fi-rr-arrow-left.svg" alt="left" />
        <span>Back</span>
    </p>

</div>
<div class="driver-information">
    <div class="information-inner">
        <h4>{{ dispatherId ? 'Group Operator Information' : 'Parker Information' }}</h4>
        <div class="action-item">
            <div class="account-id">
                <p><strong>Account ID -</strong> {{driverDetails?.userUniqueId}}</p>
            </div>
            <div class="export-btn" (click)="showData(driverId);menu.toggle($event)">
                <span class="action-driver">Actions</span>

                <img src="assets/images/bluefull-dropdown.svg" alt="" />

</div>
        </div>
    </div>
    <div class="basic-information">
        <div class="table-card custom-tabs">

            <div class="driver-tabs">
                <p-button (onClick)="setActiveTab(0)" [class.tabs-active]="activeIndex === 0"
                    label="Basic Information" />
                <p-button (onClick)="setActiveTab(1)" [class.tabs-active]="activeIndex === 1"
                    label="{{equipmentMsg}}" />
                <p-button *ngIf="dispatherId" (onClick)="setActiveTab(3)" [class.tabs-active]="activeIndex === 3"
                    label="Parker Information" />
                <p-button (onClick)="setActiveTab(2)" [class.tabs-active]="activeIndex === 2" label="Payment Method" />
            </div>

</div>

    </div>

</div>
<p-tabView [(activeIndex)]="activeIndex">
    <p-tabPanel header="Basic Information">
        <app-driver-basic-information *ngIf="!dispatherId;else groupOpratorBasicInfo" [driverDetails]="driverDetails"
            [showInput]="showInput" [imageUrl]="imageUrl" (driverBesicData)="receiveDriverBesicData($event)">
        </app-driver-basic-information>
        <ng-template #groupOpratorBasicInfo>
            <app-group-oprator-basic-information [driverDetails]="driverDetails" [showInput]="showInput"
                [imageUrl]="imageUrl" (driverBesicData)="receiveDriverBesicData($event)">
            </app-group-oprator-basic-information>
        </ng-template>
    </p-tabPanel>
    <p-tabPanel header="Equipment Information">
        <app-equipment-info-list [addButton]="addButton" [allDriverVehicle]="allDriverVehicle"
            (rowEdit)="equipmentInfoEdit($event)" (rowDelete)="equipmentInfoDelete($event)"
            (addEquipment)="openBookingDetail(null)">
        </app-equipment-info-list>
    </p-tabPanel>
    <p-tabPanel header="Payment Method">
        <app-payment-method [driverId]="driverId"></app-payment-method>
    </p-tabPanel>
    <p-tabPanel header="Parker Information" *ngIf="dispatherId">
        <app-parker-list [groupUserId]="dispatherId"></app-parker-list>
    </p-tabPanel>
</p-tabView>

<app-notes [driverNotesHistory]="driverNotesHistory" [hasNotesPermission]="true"
    (addNotes)="callAddNotesFunction($event)">
</app-notes>
<div class="activity-outer driver-information">
    <div class="table-card custom-tabs">
        <div class="information-inner">
            <h4>Activity</h4>
            <div class="filter-box">
                <p *ngIf="isResetButton" (click)="resetFilter()">Reset</p>
                <div (click)="applyFliter()" class="apply-filter">
                    <span>Filter</span>
                    <img src="../../../../assets/images/apply-filter-icon.svg" alt="filter" />
                </div>
            </div>

        </div>

        <div class="driver-tabs">
            <p-button (onClick)="activitySetActiveTab(0)" [class.tabs-active]="activityActiveIndex === 0"
                label="One Time Bookings" />
            <p-button (onClick)="activitySetActiveTab(3)" [class.tabs-active]="activityActiveIndex === 3"
                label="Recurring Bookings" />
            <p-button (onClick)="activitySetActiveTab(1)" [class.tabs-active]="activityActiveIndex === 1"
                label="Booking Payments" />
            <p-button (onClick)="activitySetActiveTab(2)" [class.tabs-active]="activityActiveIndex === 2"
                label="Custom Invoices" />

        </div>

    </div>
</div>

<p-tabView [(activeIndex)]="activityActiveIndex">

    <div *ngIf="activityActiveIndex === 0" class="basic-tabs">
        <app-user-crm-booking [role]="role" [bookingList]="bookingList" [bookingType]="'oneTime'"
            [itemsPerPage]="itemsPerPage" [isGroupUser]="isGroupUser" [totalRecords]="totalRecords"
            [BookingCurrentSkip]="BookingCurrentSkip" [activeIndex]="activityActiveIndex"
            (pgageChnage)="onPageChange($event)" (viewInVoice)="viewInvoice($event)"
            (sendInvoiceOnMail)="sendInvoiceOnMail($event)" (navigateToBookingDetail)="navigatetoBookingDeatil($event)"
            (afterCancelApiCall)="afterCancelApiCall('BookingTab')"
            (afterMarkAsPaidOrCancel)="afterMarkAsPaidOrCancel()">
        </app-user-crm-booking>
    </div>

    <div *ngIf="activityActiveIndex === 3" class="basic-tabs">
        <app-user-crm-booking [role]="role" [bookingList]="bookingList" [bookingType]="'recurring'"
            [itemsPerPage]="itemsPerPage" [isGroupUser]="isGroupUser" [totalRecords]="totalRecords"
            [BookingCurrentSkip]="BookingCurrentSkip" [activeIndex]="activityActiveIndex"
            (pgageChnage)="onPageChange($event)" (viewInVoice)="viewInvoice($event)"
            (sendInvoiceOnMail)="sendInvoiceOnMail($event)" (navigateToBookingDetail)="navigatetoBookingDeatil($event)"
            (afterCancelApiCall)="afterCancelApiCall('BookingTab')"
            (afterMarkAsPaidOrCancel)="afterMarkAsPaidOrCancel()">
        </app-user-crm-booking>
    </div>
    <div *ngIf="activityActiveIndex === 1" class="basic-tabs">
        <app-payments-detail [paymentList]="paymentList" [itemsPerPage]="itemsPerPage"
            [paymentCurrentSkip]="paymentCurrentSkip" [totalPaymentRecords]="totalPaymentRecords"
            (onPageChangePaymentList)="onPagePaymentList($event)" (viewInvoice)="viewInvoice($event)"
            (sendInvoiceOnMail)="sendInvoiceOnMail($event)" (openInvoice)="openInvoice($event)">
        </app-payments-detail>
    </div>
    <div class="basic-tabs" *ngIf="activityActiveIndex === 2">
        <app-user-crm-custom-invoice [customInvoiceList]="customInvoiceList" [itemsPerPage]="itemsPerPage"
            [isGroupUser]="isGroupUser" [totalCustomInvoices]="totalCustomInvoices" [activeIndex]="activeIndex"
            (pageCustomInvoiceList)="onPageCustomInvoiceList($event)"
            (afterCancelApiCall)="afterCancelApiCall('InvoiceTab')" (viewInVoice)="downloadInvoice($event)"
            (sendInvoiceOnMail)="sendInvoiceOnMail($event)" (afterPayApiCall)="getParkingLotInvoiceForDriver()"
            (afterMarkAsPaidOrCancel)="afterMarkAsPaidOrCancel()">
        </app-user-crm-custom-invoice>
    </div>
</p-tabView>

<div class="custom-export"> <p-menu #menu [model]="items" [popup]="true"></p-menu></div>
